import { MagnifyingGlass } from '@phosphor-icons/react';
import { LessonHistoryFilters } from '../../types/history';

interface FilterSidebarProps {
  filters: LessonHistoryFilters;
  onFiltersChange: (filters: LessonHistoryFilters) => void;
  subjects: string[];
}

export default function FilterSidebar({
  filters,
  onFiltersChange,
  subjects,
}: FilterSidebarProps) {
  return (
    <div className="layout-content-container flex flex-col w-[360px]">
      <h3 className="text-white text-lg font-bold leading-tight tracking-[-0.015em] px-4 pb-2 pt-4">
        Filter & Search
      </h3>
      
      {/* Search Input */}
      <div className="flex max-w-[480px] flex-wrap items-end gap-4 px-4 py-3">
        <label className="flex flex-col min-w-40 flex-1">
          <div className="relative">
            <input
              type="text"
              value={filters.searchText || ''}
              onChange={(e) => onFiltersChange({ ...filters, searchText: e.target.value || undefined })}
              placeholder="Search lessons..."
              className="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded text-white focus:outline-0 focus:ring-0 border border-border-light bg-input-bg focus:border-border-light h-14 placeholder:text-text-secondary pl-12 pr-4 text-base font-normal leading-normal"
            />
            <MagnifyingGlass 
              size={20} 
              className="absolute left-4 top-1/2 transform -translate-y-1/2 text-text-secondary" 
            />
          </div>
        </label>
      </div>
      
      {/* Subject Filter */}
      <div className="flex max-w-[480px] flex-wrap items-end gap-4 px-4 py-3">
        <label className="flex flex-col min-w-40 flex-1">
          <select
            value={filters.subject || ''}
            onChange={(e) => onFiltersChange({ ...filters, subject: e.target.value || undefined })}
            className="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded text-white focus:outline-0 focus:ring-0 border border-border-light bg-input-bg focus:border-border-light h-14 bg-[image:--select-button-svg] placeholder:text-text-secondary p-[15px] text-base font-normal leading-normal"
          >
            <option value="">All Subjects</option>
            {subjects.map((subject) => (
              <option key={subject} value={subject}>
                {subject}
              </option>
            ))}
          </select>
        </label>
      </div>

      {/* Clear Filters Button */}
      {(filters.subject || filters.searchText) && (
        <div className="flex max-w-[480px] flex-wrap items-end gap-4 px-4 py-3">
          <button
            onClick={() => onFiltersChange({})}
            className="flex min-w-[84px] max-w-[480px] cursor-pointer items-center justify-center overflow-hidden rounded h-10 px-4 bg-border text-white text-sm font-medium leading-normal w-full"
          >
            Clear Filters
          </button>
        </div>
      )}
    </div>
  );
}
